/**
 * TypeScript twin of the backend `ServiceWorkOrderPlanningFilterKeys` constants
 * (Digiwall.GoliathDocuments.Planning, Domain.Shared). These strings are the FE↔BE contract — a wrong
 * key silently no-ops (the backend applier ignores unknown keys), so keep both sides in sync.
 */
export const ServiceWorkOrderPlanningFilterKeys = {
  dayBook: 'DayBook',
  customer: 'Customer',
  interventionType: 'InterventionType',
  article: 'Article',
  description: 'Description',
  displayNumber: 'DisplayNumber',
} as const;

export type ServiceWorkOrderPlanningFilterKey =
  (typeof ServiceWorkOrderPlanningFilterKeys)[keyof typeof ServiceWorkOrderPlanningFilterKeys];

/** Dropdown (multi-select) filters — the only ones allowed to carry preset values. */
export const SERVICE_WORK_ORDER_DROPDOWN_KEYS: ServiceWorkOrderPlanningFilterKey[] = [
  ServiceWorkOrderPlanningFilterKeys.dayBook,
  ServiceWorkOrderPlanningFilterKeys.customer,
  ServiceWorkOrderPlanningFilterKeys.interventionType,
  ServiceWorkOrderPlanningFilterKeys.article,
];

/** Free-text filters — client-side substring only, never carry preset values. */
export const SERVICE_WORK_ORDER_TEXT_KEYS: ServiceWorkOrderPlanningFilterKey[] = [
  ServiceWorkOrderPlanningFilterKeys.description,
  ServiceWorkOrderPlanningFilterKeys.displayNumber,
];
